import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "radio", "otherField", "otherInput", "submit", "cadence", "period"]

  connect() {
    this.refresh()
  }

  refresh() {
    const selected = this.radioTargets.find(radio => radio.checked)
    const otherSelected = selected?.value === "other"

    this.cardTargets.forEach(card => {
      card.dataset.selected = String(card.dataset.seriesTypeKey === selected?.value)
    })

    if (this.hasOtherFieldTarget) this.otherFieldTarget.hidden = !otherSelected
    if (this.hasOtherInputTarget) this.otherInputTarget.required = otherSelected

    if (this.hasCadenceTarget) {
      this.periodTargets.forEach(group => {
        const visible = group.dataset.seriesTypePeriod === this.cadenceTarget.value
        group.hidden = !visible
        group.querySelector("select").required = visible
      })
    }

    if (this.hasSubmitTarget) {
      const customTypeMissing = otherSelected && this.otherInputTarget.value.trim() === ""
      this.submitTarget.disabled = !selected || customTypeMissing
    }
  }
}
